"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var __1 = require("../..");
var getFiltersFromColumnData_1 = __importDefault(require("../../utils/getFiltersFromColumnData"));
var TableColumnMenu = function (_a) {
    var _b;
    var column = _a.column, data = _a.data, order = _a.order, onSort = _a.onSort, onHide = _a.onHide, filters = _a.filters, onFilter = _a.onFilter, backendOperations = _a.backendOperations, _c = _a.disabled, disabled = _c === void 0 ? false : _c;
    var _d = __read((0, react_1.useState)(false), 2), open = _d[0], setOpen = _d[1];
    var filterCounts = [];
    var ref = (0, react_1.useRef)(null);
    var options = [];
    if (column.filter) {
        filterCounts = backendOperations ? ((_b = column.columnFilters) !== null && _b !== void 0 ? _b : []) : (0, getFiltersFromColumnData_1.default)(data, column);
    }
    filterCounts.forEach(function (f) {
        options.push({ label: f.label, checked: filters.includes(f.label), unchecked: !filters.includes(f.label), checkInfo: f.count });
    });
    if (column.sortable !== false) {
        if (column.filter) {
            options.push({ divider: true });
        }
        options.push({ label: 'Sort Ascending', leadingIcon: 'filter_list', className: 'ui-menu-item-icon-rotate' });
        options.push({ label: 'Sort Descending', leadingIcon: 'filter_list' });
    }
    if (column.canHide) {
        if (column.filter || column.sortable !== false) {
            options.push({ divider: true });
        }
        options.push({ label: 'Hide Column', leadingIcon: 'hide_source' });
    }
    if (options.length === 0) {
        return null;
    }
    if (!column.label) {
        return null;
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(__1.Button, { icon: "arrow_drop_down", variant: "tertiary", onClick: function () { return setOpen(true); }, disabled: disabled, 
            /* @ts-ignore */
            ref: ref }),
        react_1.default.createElement(__1.Menu, { open: open, trigger: ref.current, options: options, onClick: function (option) {
                switch (option.label) {
                    case 'Sort Ascending':
                        onSort('asc');
                        setOpen(false);
                        break;
                    case 'Sort Descending':
                        onSort('desc');
                        setOpen(false);
                        break;
                    case 'Hide Column':
                        onHide();
                        setOpen(false);
                        break;
                    default:
                        var newFilters = filters.includes(option.label) ? filters.filter(function (f) { return f !== option.label; }) : __spreadArray(__spreadArray([], __read(filters), false), [option.label], false);
                        onFilter(newFilters);
                }
            }, onClose: function () { return setOpen(false); }, placement: "bottom-end" })));
};
exports.default = TableColumnMenu;
